import React from 'react';
import {useFormikContext} from 'formik';
import {Modal} from 'react-bootstrap';
import {GreenButton, WhiteButton} from '@styled';
import styled from 'styled-components';

const StyledOLWrapper = styled.div`
  ol[type='1'] {
    list-style-type: none;
    counter-reset: item;
    margin: 0;
    padding: 0;
  }

  ol[type='1'] > li {
    display: table;
    counter-increment: item;
    margin-bottom: 0.6em;
  }

  ol[type='1'] > li:before {
    content: counters(item, '.') '. ';
    display: table-cell;
    padding-right: 0.6em;
  }

  li ol[type='1'] > li {
    margin: 0;
  }

  li ol[type='1'] > li:before {
    content: counters(item, '.') ' ';
  }
`;

const TermsAndConditions = ({show, onHide, onAgree}) => {
  const {setFieldValue} = useFormikContext();
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header>
        <Modal.Title>Terms & Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          The Data Portal is owned and operated by the Portal Owners. These
          Terms and Conditions (“Terms and Conditions”) are a contract between
          you (“the User”) and Portal Owners governing your use of the Data
          Portal. You must read and accept these terms and conditions before
          accessing the Data Portal, otherwise you will be unable to access the
          Data Portal.
        </p>
        <p>
          BY CLICKING ON THE “AGREE” BUTTON, YOU INDICATE YOUR ACKNOWLEDGEMENT
          AND AGREEMENT TO THE TERMS AND CONDITIONS SET OUT ON THIS PAGE.
        </p>
        <StyledOLWrapper>
          <ol type="1">
            <li>
              <p className="font-weight-bold">Use of Data Portal</p>
              <ol type="1">
                <li>
                  <p>
                    Portal Owners hereby grants to User, and User hereby
                    accepts, subject to the terms and conditions set forth in
                    this Agreement, a non-exclusive and non-transferable right
                    to access the Data Portal.
                  </p>
                </li>
                <li>
                  <p>
                    User is solely responsible for ensuring that all
                    information, data, text, or other materials that User
                    provides to Portal Owners through the use of the Data Portal
                    (Content) are true, accurate, and complete.
                  </p>
                </li>
                <li>
                  <p>
                    Portal Owners has included (as part of Data Portal) security
                    features including password protection to prevent a person
                    other than the User from obtaining access through the Data
                    Portal to User&apos;s Content. User understands that these
                    security features depend on User protecting its password
                    from disclosure to unauthorized persons. User also
                    understands and acknowledges that despite security measures
                    to prohibit unauthorized access to the Content through the
                    Data Portal, unauthorized access could occur and in the
                    event it does, Portal Owners may not be held liable for the
                    unauthorized release of information, data, text or other
                    materials that have been submitted to Portal Owners using
                    the Data Portal.
                  </p>
                </li>
                <li>
                  <p>
                    Portal Owners has included (as part of Data Portal) security
                    features including password protection to prevent a person
                    other than the User from obtaining access through the Data
                    Portal to User&apos;s Content. User understands that these
                    security features depend on User protecting its password
                    from disclosure to unauthorized persons. User also
                    understands and acknowledges that despite security measures
                    to prohibit unauthorized access to the Content through the
                    Data Portal, unauthorized access could occur and in the
                    event it does, Portal Owners may not be held liable for the
                    unauthorized release of information, data, text or other
                    materials that have been submitted to Portal Owners using
                    the Data Portal.
                  </p>
                </li>
                <li>
                  <p>
                    Portal Owners will use reasonable endeavors to minimize data
                    loss in the event of technical or system failure. However,
                    the User is responsible for maintaining a complete record,
                    independent of the Data Portal, of all relevant information.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p className="font-weight-bold">Restrictions</p>
              <p>
                The permission granted in Section 1 above is expressly made
                subject to and limited by the following restrictions, in
                addition to the limitations and restrictions set forth in other
                sections of the Agreement:
              </p>
              <ol type="1">
                <li>
                  <p>
                    User agrees not to access the Data Portal by any means other
                    than using internet browsers.
                  </p>
                </li>
                <li>
                  <p>
                    User further agrees that it will NOT use any robot, spider,
                    other automatic device or manual process to monitor or copy
                    any Data Portal pages or any content included therein
                    without Portal Owners&apos; prior written permission. You
                    further agree that you will not (a) use any device,
                    software, or routine to interfere or attempt to interfere
                    with the proper working of the Data Portal or (b) take any
                    action that imposes an unreasonable or disproportionately
                    large load on the Data Portal&apos;s infrastructure as
                    determined by Portal Owners in its own discretion and (c)
                    you will not reverse engineer, translate, adapt or modify
                    any software used in connection with any part of the Data
                    Portal, and you will not (d) attempt to use the Data Portal
                    to access information, data, text, or other materials
                    submitted by other Users of the Data Portal.
                  </p>
                </li>
                <li>
                  <p>
                    User&apos;s right to access the Data Portal automatically
                    terminates upon User&apos;s violation of any provisions of
                    this Agreement.
                  </p>
                </li>
                <li>
                  <p>
                    User will immediately notify Portal Owners of any
                    unauthorized use of User&apos;s login information or account
                    associated with the Data Portal, any known or suspected
                    breach in login confidentiality, or other breach of security
                    related to User&apos;s account.
                  </p>
                </li>
                <li>
                  <p>
                    If, at anytime, User determines it is no longer able or
                    willing to abide by the terms of this Agreement, User shall
                    immediately cease all use of Data Portal and promptly notify
                    Portal Owners in writing of its determination so that Portal
                    Owners may formally suspend or revoke the User&apos;s access
                    to the Data Portal system.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p className="font-weight-bold">No Warranties</p>
              <p>
                USE OF THE DATA PORTAL IS AT YOUR OWN RISK. ALL CONTENT ON THE
                DATA PORTAL IS PROVIDED TO YOU ON AN “AS IS”, “AS AVAILABLE”
                BASIS WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED,
                INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                NON-INFRINGEMENT. WHILE THE CONTENT AVAILABLE THROUGH THE
                WEBSITE WAS BELIEVED TO BE ACCURATE AS OF THE DATE IT WAS
                PREPARED, Portal Owners MAKES NO WARRANTY AS TO THE ACCURACY,
                COMPLETENESS OR TIMELINESS OF ANY SUCH CONTENT. YOU SHOULD
                VERIFY ANY CONTENT BEFORE RELYING ON IT. YOU ARE RESPONSIBLE FOR
                TAKING ALL NECESSARY PRECAUTIONS TO ENSURE THAT ANY CONTENT YOU
                MAY OBTAIN FROM THE WEBSITE IS FREE OF VIRUSES. Portal Owners
                MAKES NO REPRESENTATIONS OR WARRANTIES THAT USE OF THE WEBSITE
                WILL BE UNINTERRUPTED OR ERROR-FREE.
              </p>
            </li>
            <li>
              <p className="font-weight-bold">Limitation of Liability</p>
              <p>
                In no event shall Portal Owners, its affiliated parties, or any
                of their agents, representatives, or licensors be liable to you
                for any direct, indirect, incidental, consequential, or special
                damages, even if advised of the possibility of such damages,
                arising out of or in any way connected with your access to or
                use of the Data Portal, whether based on breach of contract,
                tort (including negligence and strict liability) or any other
                theory, including but not limited to your reliance on any
                content obtained through the use of Data Portal, or mistakes or
                omissions in, or delays in transmission of, information to or
                from you, interruptions in telecommunications connections to the
                Data Portal or viruses, whether caused in whole or in part by
                negligence, acts of god, telecommunications failure, theft or
                destruction of, or unauthorized access to, the Data Portal.
              </p>
              <p>
                YOU HEREBY WAIVE ANY AND ALL CLAIMS AGAINST Portal Owners, ITS
                AFFILIATED PARTIES, OR ANY OF THEIR AGENTS, REPRESENTATIVES, OR
                LICENSORS ARISING OUT OF, OR IN ANY WAY CONNECTED TO YOUR USE OF
                THE WEBSITE AND/OR SERVICES PROVIDED THROUGH THE WEBSITE.
              </p>
            </li>
            <li>
              <p className="font-weight-bold">Intellectual Property Rights</p>
              <p>
                The Data Portal is protected by copyright laws. Except for your
                personal, informational, and as otherwise expressly authorized
                within the Data Portal, you may not reproduce, modify or
                distribute any text, graphics or other content on the Data
                Portal without written permission from Portal Owners.
              </p>
            </li>
            <li>
              <p className="font-weight-bold">Indemnification</p>
              <p>
                You hereby indemnify to the fullest extent Portal Owners from
                and against any and/or all liabilities, costs, demands, causes
                of action, damages and expenses arising in any way related to
                your breach of any of the provisions of these Terms.
              </p>
            </li>
            <li>
              <p className="font-weight-bold">Confidentiality</p>
              <ol type="1">
                <li>
                  <p>
                    We will not disclose or publish any information provided to
                    Us except where
                  </p>
                  <ol type="a">
                    <li>
                      <p>disclosure or publication is:</p>
                    </li>
                    <ol type="i">
                      <li>
                        <p>
                          required under the Regulations or otherwise by law;
                        </p>
                      </li>
                      <li>
                        <p>
                          necessary for Us to perform our functions under the
                          Regulations; or
                        </p>
                      </li>
                      <li>
                        <p>made with Your consent; or</p>
                      </li>
                    </ol>
                    <li>
                      <p>
                        disclosure is between Us, Portal Owners and the
                        Appropriate Authorities.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <p className="font-weight-bold">Suspension or Termination</p>
              <ol type="1">
                <li>
                  <p>
                    We may suspend or terminate Your access to the Data Portal
                    immediately at any time without notice in the event that we
                    reasonably believe that You have breached any of these Terms
                    or might do so, or where We are required or authorized by
                    law to do so.
                  </p>
                </li>
                <li>
                  <p>Clauses 3, 4, 5, 6, 7, and 9 shall survive termination.</p>
                </li>
              </ol>
            </li>
            <li>
              <p className="font-weight-bold">General</p>
              <ol type="1">
                <li>
                  <p>
                    These Terms and Conditions, as modified from time to time
                    and including any policies that are incorporated by
                    reference, sets forth the entire understanding and agreement
                    between you and Portal Owners with respect to the subject
                    matter hereof. Portal Owners shall not be liable for any
                    delay or failure in performance under these Terms and
                    Conditions or interruption of service resulting from acts of
                    God, civil or military authority, war, labor disputes,
                    materials provided by third parties or any cause beyond the
                    reasonable control of Portal Owners. Portal Owners&apos;s
                    failure to exercise any right or provision of these Terms
                    and Conditions shall not constitute a waiver of such right
                    or provision. If any provision of these Terms and Conditions
                    is found by a court to be invalid, the parties nevertheless
                    agree that the court should endeavor to give effect to the
                    parties&apos; intentions as reflected in the provision and
                    the other provisions of these Terms and Conditions remain in
                    full force and effect. The section titles in these Terms and
                    Conditions are for convenience only and have no legal or
                    contractual effect.
                  </p>
                </li>
                <li>
                  <p>
                    Portal Owners reserves the right to modify these Terms and
                    Conditions from time to time and such modification shall be
                    effective upon posting by Portal Owners on this Data Portal.
                    Such modifications will be denoted by the “last updated”
                    notice at the top of this page. Please check these Terms and
                    Conditions periodically for updates or changes. Your
                    continued use of this Data Portal following the posting of
                    any changes constitutes acceptance of those changes.
                  </p>
                </li>
                <li>
                  <p>
                    These Terms and Conditions shall be governed, interpreted
                    and construed in accordance with the laws of Saudi Arabia.
                    The information provided on this Data Portal is not intended
                    for distribution to, or use by, any person or entity in any
                    jurisdiction or country where such distribution or use would
                    be contrary to law or regulation or which would subject
                    Portal Owners or its affiliates to any registration
                    requirement within such jurisdiction or country. Portal
                    Owners makes no representation that the information in the
                    Data Portal is appropriate or available for use in other
                    locations, and access to the Data Portal from territories
                    where the content of the Data Portal or use of the products
                    offered herein may be illegal is prohibited. Those who
                    choose to access the Data Portal from other locations do so
                    on their own initiative and are responsible for compliance
                    with applicable local laws.
                  </p>
                </li>
              </ol>
            </li>
          </ol>
        </StyledOLWrapper>
      </Modal.Body>
      <Modal.Footer className="justify-content-start">
        <GreenButton
          variant="secondary"
          onClick={() => {
            setFieldValue('agreeTerms', ['1']);
            onAgree();
          }}
        >
          Agree
        </GreenButton>
        <WhiteButton variant="secondary" onClick={onHide}>
          Cancel
        </WhiteButton>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsAndConditions;
